module.exports = __webpack_public_path__ + "quicksilver/static/media/no-flights-found.110b7b66.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/no-flights-found.png
// module id = 185
// module chunks = 0